// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OnlineDiskWrapper_wrapper__2sbDZ"};